import React from 'react';

/**
 * Expandable prompt list displayed inside a chapter card.
 * Each prompt is a clickable item that could navigate to a story creation flow.
 *
 * Props:
 *   prompts   - array of { id, text, age_range?, answered? }
 *   memberId  - family member UUID
 *   chapterId - chapter UUID
 */
function ChildChapterPrompts({ prompts, memberId, chapterId, note }) {
  if (!prompts || prompts.length === 0) {
    return (
      <p className="text-sm text-gray-400 italic py-2">
        {note || 'No prompts available for this chapter yet.'}
      </p>
    );
  }

  return (
    <ul className="space-y-2 mt-3">
      {prompts.map((prompt, idx) => {
        const isAnswered = prompt.answered;
        return (
          <li key={prompt.id || idx}>
            <button
              className={`w-full text-left px-3 py-2.5 rounded-lg text-sm transition-colors ${
                isAnswered
                  ? 'bg-[#556B2F]/5 text-gray-500 line-through'
                  : 'bg-white hover:bg-[#556B2F]/10 text-gray-700'
              }`}
              disabled={isAnswered}
            >
              <span className="mr-2">{isAnswered ? '\u2705' : '\u270F\uFE0F'}</span>
              {prompt.text}
            </button>
          </li>
        );
      })}
    </ul>
  );
}

export default ChildChapterPrompts;
